import React from "react";

const NS_COLORS = {
  A: { bg: "#038141", text: "#FFFFFF" },
  B: { bg: "#85BB2F", text: "#FFFFFF" },
  C: { bg: "#FECB02", text: "#1A1A1A" },
  D: { bg: "#EE8100", text: "#FFFFFF" },
  E: { bg: "#E63E11", text: "#FFFFFF" },
};

/**
 * Kompakter Nutri-Score-Badge (Letter A-E auf farbigem Hintergrund).
 * size: "sm" | "md" | "lg"
 */
export function NutriScoreBadge({ score, size = "md" }) {
  if (!score || !score.grade) return null;
  const { grade, points } = score;
  const cfg = NS_COLORS[grade] || { bg: "#71717A", text: "#FFFFFF" };
  const dim = size === "sm" ? 28 : size === "lg" ? 56 : 40;
  const fontSize = size === "sm" ? 14 : size === "lg" ? 28 : 20;
  return (
    <div className="inline-flex items-center gap-2" data-testid={`nutri-score-${grade}`}>
      <div
        className="rounded-md flex items-center justify-center font-bold leading-none"
        style={{
          backgroundColor: cfg.bg,
          color: cfg.text,
          width: dim,
          height: dim,
          fontSize,
        }}
      >
        {grade}
      </div>
      {size !== "sm" && (
        <div className="text-xs">
          <div className="uppercase tracking-widest text-[10px] text-zinc-500">Nutri-Score</div>
          <div className="font-mono-num text-zinc-700">Pkt. {points}</div>
        </div>
      )}
    </div>
  );
}
